import { useQuery } from '@tanstack/react-query';
import { getProductById } from 'api/auth.api';

export const useProductById = (id) => {
  return useQuery({
    queryKey: ['productById', id],
    queryFn: () => getProductById(id),
    enabled: !!id,
  });
};
